import React from "react";
import "../PlanManagements/PlanManagements.scss";
import GenerateTestTable from "./DocumentUploadTable";

const GenerateTest = () => {
  return (
    <>
    <div className='admin-content-wrapper'>
      <div className="admin-content-subheader">
        <div className="admin-content-subheader-title">Document</div>
      </div>

      <GenerateTestTable />
    </div>
    </>
  );
};

export default GenerateTest;
